import { render, staticRenderFns } from "./professionalReportDetail.vue?vue&type=template&id=05ba704a&scoped=true&"
import script from "./professionalReportDetail.vue?vue&type=script&lang=js&"
export * from "./professionalReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./professionalReportDetail.vue?vue&type=style&index=0&id=05ba704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba704a",
  null
  
)

export default component.exports